import * as api from "./api";
import * as modelsGet from "../models/get";
import * as modelsPost from "../models/post";
import * as moment from "moment";

export function getAppointments(start?: moment.Moment, end?: moment.Moment, exactTime: boolean = false, withArchived: boolean = false): JQueryPromise<modelsGet.IAppointment[]>
{
    var endpoint = new URI("api/appointments");
    endpoint.addQuery({
        start: ((start != null) ? start.toISOString() : undefined),
        end: ((end != null) ? end.toISOString() : undefined),
        exactTime: exactTime,
        withArchived: withArchived
    });

    return api.get<modelsGet.IAppointment[]>({
        endpoint: endpoint.href()
    });
}